import { api } from '@/shared/api/client-api'
import { methods } from '@/shared/api/constants'
import { API_END_POINTS } from '@/shared/api/end-points'

export type CreateGrowthPointBasicsParams = {
  projectId: string
}

const createGrowthPointBasics = async ({ projectId }: CreateGrowthPointBasicsParams) => {
  return api.json<unknown>(API_END_POINTS.project.createGrowthPointBasics({ projectId }), {
    method: methods.post,
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export default createGrowthPointBasics
